// extracted by mini-css-extract-plugin
module.exports = {"page-container":"style_page-container__2lsBd","page-list":"style_page-list__RlkJT","page-content":"style_page-content__1qIfO","active-link":"style_active-link__1qk6B"};